export default function ($rootScope, Config, screenSaver) {

    $rootScope.solutions = [];
    $rootScope.categories = [];
    $rootScope.products = [];
    $rootScope.services = [];

    Config.init();
    screenSaver.init();
}


// WEBPACK FOOTER //
// ./src/app/init.js